<mat-icon *ngIf="icon">{{icon}}</mat-icon>
<div class="caption">{{caption}}</div>
